var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuror({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.78491H8L4.5 14L1 7.78491Z",
    stroke: "#C7A267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52197 0.5C5.90797 0.5 7.04639 1.64517 7.04639 3.0752C7.04625 4.5051 5.90789 5.64941 4.52197 5.64941C3.13623 5.6492 1.99867 4.50497 1.99854 3.0752C1.99854 1.6453 3.13615 0.500212 4.52197 0.5Z",
    stroke: "#C7A267"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6001 2.59998C10.8762 2.59998 11.1001 2.82383 11.1001 3.09998V9.09998C11.1001 9.37612 10.8762 9.59998 10.6001 9.59998H5.6001C5.32396 9.59998 5.1001 9.37612 5.1001 9.09998V3.09998C5.1001 2.82383 5.32396 2.59998 5.6001 2.59998H10.6001ZM7.59619 5.40564L6.67334 5.63611L7.28369 6.36462L7.21826 7.31384L8.1001 6.95837L8.98193 7.31384L8.9165 6.36462L9.52686 5.63611L8.604 5.40564L8.1001 4.59998L7.59619 5.40564Z",
    fill: "#C7A267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuror);
export default __webpack_public_path__ + "static/media/Juror.a0d921634dcda9ae01bfebe6fba18697.svg";
export { ForwardRef as ReactComponent };